import { Phone } from "lucide-react";

const links = [
  { label: "Why Us", href: "#ethos" },
  { label: "Services", href: "#services" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-ink/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-4 sm:px-8">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center bg-ember font-display text-xl font-black text-white">
            F
          </span>
          <span className="font-display text-xl font-extrabold uppercase tracking-wide text-white">
            FlatlanderTrucking<span className="text-ember">.com</span>
          </span>
        </a>
        <nav className="hidden items-center gap-8 lg:flex" data-testid="header-nav">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400 transition-colors duration-200 hover:text-ember"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <span
            data-testid="header-status-badge"
            className="hidden items-center gap-2 border border-ember/40 bg-ember/10 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-ember md:flex"
          >
            <span className="relative flex h-2 w-2">
              <span className="absolute h-full w-full animate-pulse-ring rounded-full bg-ember" />
              <span className="h-2 w-2 rounded-full bg-ember" />
            </span>
            24/7 Dispatch
          </span>
          <a
            href="tel:+13302014612"
            data-testid="header-call-button"
            className="hidden items-center gap-2 border border-white/20 px-4 py-2 font-mono text-xs uppercase tracking-widest text-white transition-colors duration-200 hover:border-ember hover:text-ember sm:flex"
          >
            <Phone className="h-3.5 w-3.5" />
            (330) 201-4612
          </a>
          <a
            href="#request"
            data-testid="header-request-tow-button"
            className="bg-ember px-4 py-2 font-mono text-xs font-bold uppercase tracking-widest text-white transition-colors duration-200 hover:bg-emberdark"
          >
            Request a Tow
          </a>
        </div>
      </div>
    </header>
  );
}
